import { IconX } from '@tabler/icons-react';
import { ActionIcon, Anchor, Box, Group, Text } from '@mantine/core';
import { MIGRATION_BANNER_HEIGHT } from '../../constants/ui/header';

interface IMigrationBannerProps {
  onClose?: () => void;
}

export function MigrationBanner({ onClose }: IMigrationBannerProps) {
  return (
    <Box
      w="100%"
      bg="brand.4"
      py="0.3rem"
      pos="relative"
      h={MIGRATION_BANNER_HEIGHT}
    >
      <Group align="center" justify="center" w="100%" h="100%">
        <Text c="white" fz="sm" visibleFrom="sm">
          Link untuk mengakses sistem Healthy One sudah berubah menjadi{' '}
          <Anchor
            href="https://sim.healthyone.app"
            c="white"
            fz="sm"
            underline="always"
          >
            https://sim.healthyone.app
          </Anchor>
        </Text>
        <Text hiddenFrom="sm" c="white" fz="xs" ml="-1rem">
          Link akses Healthy One{' '}
          <Anchor
            href="https://sim.healthyone.app"
            c="white"
            fz="xs"
            underline="always"
          >
            sim.healthyone.app
          </Anchor>
        </Text>
      </Group>
      <ActionIcon
        pos="absolute"
        className="top-1/2 right-2 -translate-y-1/2"
        size="sm"
        bg="transparent"
        onClick={onClose}
      >
        <IconX />
      </ActionIcon>
    </Box>
  );
}
